import { BrowserRouter } from "react-router";

import TelehealthRoutes from "./telehealth/routes/TelehealthRoutes";
import LoadingLayer from "./telehealth/components/Loading";
import { useLoadingContext } from "./context/roomContext";

export default function App() {
  const { loading, loadingText } =
    useLoadingContext();

  return (
    <BrowserRouter>
      <TelehealthRoutes />

      {loading && (
        <LoadingLayer content={loadingText} />
      )}
    </BrowserRouter>
  );
}